import { FC } from 'react';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { Edit16 } from 'ui/icons';

export const CAMPAIGN_OVERRRIDES_TRIGGER_ID = 'open-alert-settings-takeover';

type AlertTakeoverProps = {
  isDisabled?: boolean;
  onTakeoverOpen: (isOpen: boolean) => void;
};

export const CampaignOverridesTrigger: FC<AlertTakeoverProps> = ({
  isDisabled = false,
  onTakeoverOpen,
}) => (
  <Tooltip
    isEnabled={isDisabled}
    tooltipContent={'Please create campaign first with alerts enabled to further configure alerts'}
  >
    <IconButton
      data-test={CAMPAIGN_OVERRRIDES_TRIGGER_ID}
      isDisabled={isDisabled}
      onClick={() => onTakeoverOpen(true)}
      variant={BUTTON_VARIANTS.GHOST}
    >
      <Edit16 />
    </IconButton>
  </Tooltip>
);
